var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "17px",
    viewBox: "0 0 20 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_users") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.96125,11.1285 C14.565,10.537875 16.35875,10.7685 17.76,11.74475 C19.161875,12.721625 19.999375,14.32475 20,16.0335 C20,16.3785 19.720625,16.6585 19.375,16.6585 C19.03,16.6585 18.75,16.379125 18.75,16.0335 C18.749375,14.7335 18.111875,13.5135 17.045,12.770375 C15.97875,12.026625 14.6125,11.851625 13.39375,12.301625 C13.06875,12.41975 12.710625,12.25475 12.590625,11.931 C12.471875,11.606625 12.6375,11.247875 12.96125,11.1285 Z M6.25,9.780625 C9.69625,9.780625 12.5,12.584375 12.5,16.030625 C12.5,16.37625 12.220625,16.655625 11.875,16.655625 C11.529375,16.655625 11.25,16.37625 11.25,16.030625 C11.25,13.27375 9.006875,11.030625 6.25,11.030625 C3.493125,11.030625 1.25,13.27375 1.25,16.030625 C1.25,16.37625 0.970625,16.655625 0.625,16.655625 C0.279375,16.655625 0,16.37625 0,16.030625 C0,12.584375 2.80375,9.780625 6.25,9.780625 Z M14.7729375,3.375 C16.6679375,3.375 18.2104375,4.9175 18.2104375,6.8125 C18.2104375,8.7075 16.6679375,10.25 14.7729375,10.25 C12.8779375,10.25 11.3354375,8.7075 11.3354375,6.8125 C11.3354375,4.9175 12.8779375,3.375 14.7729375,3.375 Z M6.25,0.875 C8.49,0.875 10.3125,2.6975 10.3125,4.9375 C10.3125,7.1775 8.49,9 6.25,9 C4.01,9 2.1875,7.1775 2.1875,4.9375 C2.1875,2.6975 4.01,0.875 6.25,0.875 Z M14.7729375,4.625 C13.5666875,4.625 12.5854375,5.60625 12.5854375,6.8125 C12.5854375,8.01875 13.5666875,9 14.7729375,9 C15.9791875,9 16.9604375,8.01875 16.9604375,6.8125 C16.9604375,5.60625 15.9791875,4.625 14.7729375,4.625 Z M6.25,2.125 C4.699375,2.125 3.4375,3.386875 3.4375,4.9375 C3.4375,6.488125 4.699375,7.75 6.25,7.75 C7.800625,7.75 9.0625,6.488125 9.0625,4.9375 C9.0625,3.386875 7.800625,2.125 6.25,2.125 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-01-B",
    transform: "translate(-248.000000, -94.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(232.000000, 69.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/profiles/line",
    transform: "translate(16.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon_users",
    fill: "#95C11F",
    xlinkHref: "#path-1"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers);
export default __webpack_public_path__ + "static/media/icon_users.81900d1948cec9970e49feaebaa5eb2b.svg";
export { ForwardRef as ReactComponent };